import { PaginationType } from 'common';
import { AppRootStateType } from 'state/reducers';
import { CommunityType } from 'state/reducers/communities/types';

export const selectCommunities = (state: AppRootStateType): CommunityType[] =>
  state.communities.communities;
export const selectCommunitiesSearch = (state: AppRootStateType): string | undefined =>
  state.communities.search;
export const selectCommunitiesPagination = (state: AppRootStateType): PaginationType => ({
  page: state.communities.page,
  count: state.communities.count ?? 0,
});
export const selectCertainCommunity = (state: AppRootStateType): CommunityType =>
  state.communities.certainCommunity;

export const selectCommunitiesIsLoading = (state: AppRootStateType): boolean =>
  state.communities.isLoading;
